<template>
	<div class="chat">
		<!-- 客服头像 -->
		<div class="top">
			<!-- <div class="back"><img src="../../assets/back.png" alt=""></div> -->
			<div class="name">
				<div>易伙伴-甜甜-在线客服</div>
			</div>
		</div>
		<div class="main">

			<div class="message" v-for="(item, index) in messageList" :key="index">

				<div class="message-item" ref="text">

					<div class="message-left">
						<img src="../../assets/logoUser.png" alt="" v-if="!item.isMe" />

					</div>

					<div class="content">
						<p :class="['color',item.isMe ? 'textRight' :'colorText']">{{ item.message }}</p>
					</div>

					<div class="message-right">
						<img src="../../assets/user.png" alt="" v-if="item.isMe" />

					</div>

				</div>
			</div>
		</div>
		<div>
		</div>

		<div class="bom">
			<div class="input">
				<input style="width: 80%;" type="text" v-model="input" @keyup.enter="sendMessage" placeholder="请输入消息" />
				<img v-if="input" class="btn" src="../../assets/send.png" alt="" @click="sendMessage">
				<img v-else class="btn" src="../../assets/noSend.png" alt="">
			</div>
		</div>
		<!-- <div class="main_right" style="width:30%;">
																	<p class="main_right_top">输出日志</p>
																	<p style="margin-left:10px">问答内容</p>
																	<div class="message_box">
																		<div class="message_b" v-for="(item,index) in debmessage" :key="index">
																			{{item}}
																		</div>
																	</div>
																</div> -->
	</div>
</template>

<script>
// import {
// 	getChatInfo
// } from '@/api/index'
import axios from 'axios'
export default {
	data() {
		return {
			socket: null,
			// wsUrl: homeWsUrl(),
			// websock: null,
			// websockNet: null,
			input: '',
			messageList: [{
				name: '易伙伴-甜甜-在线客服',
				message: '您好，我是客服甜甜，请问有什么可以帮到您',
				isMe: false,
				time: new Date().getTime(),
			},],
			debmessage: [],
			// 展示时间的字段
			time: '',
			// 按钮禁用
			disabled: false,
		}
	},
	mounted() {
		// 自动获取缓存聊天记录
		const chatHistory = localStorage.getItem('chat_history')
		if (chatHistory != null) {
			this.messageList = JSON.parse(chatHistory)
		}
		this.$nextTick(() => {
			this.$el.scrollTop = this.$el.scrollHeight
		})
		// 加载完毕自动滚动到最底部
		this.getConversationID()
	},
	filters: {
		// 时间格式化
		formatTime(time) {
			const date = new Date(time)
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDate()
			const hour = date.getHours()
			const minute = date.getMinutes()
			const second = date.getSeconds()
			return `${year}-${month}-${day} ${hour}:${minute}:${second}`
		},
	},
	methods: {
		// openSocket() {
		// 	let socket;
		// 	let that = this;
		// 	const socketUrl = "ws://192.168.110.33:8091/echo";
		// 	console.log(socketUrl);
		// 	if (socket != null) {
		// 		socket.close();
		// 		socket = null;
		// 	}
		// 	socket = new WebSocket(socketUrl);
		// 	//打开事件
		// 	socket.onopen = function() {
		// 		console.log("websocket已打开", );
		// 	};
		// 	//获得消息事件
		// 	socket.onmessage = function(msg) {
		// 		that.debmessage.push(msg.data)
		// 		//发现消息进入,开始处理前端触发逻辑
		// 	};
		// 	//关闭事件
		// 	socket.onclose = function() {
		// 		console.log("websocket已关闭");
		// 	};
		// 	//发生了错误事件
		// 	socket.onerror = function() {
		// 		console.log("websocket发生了错误");
		// 	}
		// },
		// 获取会话id
		getConversationID() {
			axios.get('https://cs.api.yhbzf.com/chat/getSessionId').then((res) => {
				sessionStorage.setItem('conversationID', res.data.data)
			})
		},
		async sendMessage() {
			// 非空判断
			if (this.input === '') {
				return
			}
			// vant 成功提示
			if (this.disabled)
				return this.$toast.fail({
					message: '正在加载稍后',
				})

			this.$toast.loading({
				message: '请稍后...',
				forbidClick: true,
				loadingType: 'spinner',
				duration: 0,
			})
			this.disabled = true
			// 储存聊天记录
			this.messageList.push({
				name: '我',
				message: this.input,
				isMe: true,
				time: new Date().getTime(),
			})

			const data = {
				isTrainingPattern: 0,
				prompt: this.input,
				sessionId: sessionStorage.getItem('conversationID')
			}
			this.input = ''
			// 捕获错误
			// 清空输入框
			// getChatInfo(data).then((res) => {
			axios.post('https://cs.api.yhbzf.com/chat/fineTunes/get-chat-info', data).then((res) => {
				this.messageList.push({
					name: '易伙伴-甜甜-在线客服',
					message: res.data.data.content,
					isMe: false,
					time: new Date().getTime(),
				})

				localStorage.setItem('chat_history', JSON.stringify(this.messageList))
				this.$nextTick(() => {
					this.$el.scrollTop = this.$el.scrollHeight
					// 按钮解除禁用
					this.disabled = false
					// 关闭加载提示
					this.$toast.clear()
					// vant 成功提示
					this.$toast.success({
						message: '加载成功',
						forbidClick: true,
						duration: 1000,
					})
				})
			}).catch(() => {
				this.$toast.clear()
				this.$toast.fail({
					message: '加载失败',
					forbidClick: true,
					duration: 1000,
				})
				this.disabled = false
			})

			this.disabled = true
			// 滚动到最底部
			this.$nextTick(() => {
				this.$el.scrollTop = this.$el.scrollHeight
			})
		},
		// 点击唤醒键盘自动滚动到最底部
		onFocusEvent() {
			this.$nextTick(() => {
				this.$el.scrollTop = this.$el.scrollHeight
			})
		},
	},
}
</script>

<style lang="scss">
.chat {
	position: relative;
	height: 99%;
	border: 1px solid #eee;
	overflow-y: scroll;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	background-color: #e9e9e9;

	.main {
		flex: 1;
		padding: 50px 0 70px;
	}

	.top {
		position: fixed;
		top: 0;
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		font-weight: bold;
		border-bottom: 1px solid #e7e7e7;
		background-color: #e9e9e9;

		.logoUser {
			width: 50px;
			height: 50px;
			border-radius: 50%;
			margin: 0 10px;
		}

		.back {
			width: 6px;
			height: 17px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.name {
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			height: 50px;
			line-height: 50px;
			text-align: center;
		}
	}
}


.message {
	display: flex;
	justify-content: space-between;

	.message-item {
		display: flex;
		width: 100%;
		margin: 5px;
	}

	.message-left {
		width: 38px;
		height: 38px;
	}

	.message-right {
		width: 38px;
		height: 38px;
	}
}

.message-item img {
	margin-top: 5px;
	width: 38px;
	height: 38px;
	image-rendering: -webkit-optimize-contrast; // border-radius: 50%;
}

.color {
	background-color: #00bfff;
	width: fit-content;
}

.content {
	// 留出头像的位置
	flex: 1;
	margin: 0 10px;

	.color {
		// 控制换行
		font-weight: normal;
		word-break: break-all;
		text-align: left; // font-size: 12px;
	}
}

.textRight {
	// 浮动到右边
	float: right;
	background: #89d961;
	color: #48243a;
}

.message-item .name {
	font-size: 12px;
	color: #999;
	margin-bottom: 5px;
}

.message-item p {
	border: 1px solid #eee;
	padding: 10px;
	border-radius: 5px;
	margin-top: 5px;
	margin-bottom: 10px;
}

.me {
	flex-direction: row-reverse;
	text-align: right;
}

.iconMe {
	margin-left: 5px;
}

.bom {
	position: fixed;
	bottom: 0;
	/* 宽度100% */
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #f2f2f2;

	.btn {
		position: relative;
		top: 5px;
		width: 20px;
		height: 20px;
		margin-left: 10px;
	}
}

.input {
	flex: 1;
	padding: 10px;
	border: none;
	border-radius: 5px;
	border-top: 1px solid #ebebeb; // 页面滚动时，输入框bottom固定在底部
}

input {
	padding: 10px;
	border: none;
}

.colorText {
	// 气泡样式
	border-radius: 5px;
	background-color: #fff;
}

.time {
	// 时间样式，居中
	margin: 20px 0;
	width: 100%;
	text-align: center;
	color: #999;
	font-size: 12px;
}
</style>